import { PlaceTypeNameEnum } from '@aviv_price-pages/brand';
import { isPlaceInsideCity } from '@/helpers/geo/places';
/**
 * Return the place to be used to display prices layers depending on criteria
 *
 * @param place - The current place
 * @returns The place
 */
export const getPlaceForPricesLayers = (place) => {
    /**
     * Retrieve city for place inside a city
     * If the requested place is below inside a city, we still want show prices layers for the city
     */
    if (isPlaceInsideCity(place.typeKey)) {
        return place.parents?.[PlaceTypeNameEnum.MUNICIPALITY];
    }
    return place;
};
